import WideoObject from '../../../common/core/WideoObject';
import { Class } from '../../../common/core/model/WideoDef';
import EditorMaskedObject from '../objects/EditorMaskedObject';
import EditorMaskObject from '../objects/EditorMaskObject';
import EditorPlaceholder from '../objects/EditorPlaceholder';
import EditorObject from '../objects/EditorObject';
import EditorImageObject from '../objects/EditorImageObject';
import EditorShapeObject from '../objects/EditorShapeObject';
import EditorAnimatedObject from '../objects/EditorAnimatedObject';
import EditorVideoObject from '../objects/EditorVideoObject';
import EditorAudioObject from '../objects/EditorAudioObject';
import EditorAnimatedObjectGroup from '../objects/EditorAnimatedGroupObject';
import EditorTextObject from '../objects/EditorTextObject';

import * as PIXI from 'pixi.js-legacy';
import EditorObjectGroup from '../objects/EditorObjectGroup';

export default class EditorDef {

  public static isEditorObject(displayObject: PIXI.DisplayObject): displayObject is EditorObject {
    const object: EditorObject = (displayObject as EditorObject);
    return (object.isEditorObject !== undefined) && (object.isEditorObject() === true);
  }

  public static isObjectGroup = (object: WideoObject): object is EditorObjectGroup => {
    return (object && object.getClass() === Class.ObjectGroup);
  }
  public static isMaskedObject = (object: WideoObject): object is EditorMaskedObject => {
    return (object && object.getClass() === Class.MaskedObject);
  }
  public static isMaskObject = (object: WideoObject): object is EditorMaskObject => {
    return (object && object.getClass() === Class.MaskObject);
  }
  public static isPlaceholder = (object: WideoObject): object is EditorPlaceholder => {
    return (object && object.getClass() === Class.Placeholder);
  }
  public static isTextObject = (object: WideoObject): object is EditorTextObject => {
    return (object && object.getClass() === Class.TextObject);
  }
  public static isShapeObject = (object: WideoObject): object is EditorShapeObject => {
    return (object && object.getClass() === Class.ShapeObject)
  }
  public static isImageObject = (object: WideoObject): object is EditorImageObject => {
    return (object && object.getClass() === Class.ImageObject)
  }
  public static isAnimatedObject = (object: WideoObject): object is EditorAnimatedObject => {
    return (object && object.getClass() === Class.AnimatedImageObject)
  }
  public static isAnimatedGroupObject = (object: WideoObject): object is EditorAnimatedObjectGroup => {
    return (object && object.getClass() === Class.AnimatedGroupObject)
  }
  public static isVideoObject = (object: WideoObject): object is EditorVideoObject => {
    return (object && object.getClass() === Class.VideoObject)
  }
  public static isAudioObject = (object: WideoObject): object is EditorAudioObject => {
    return (object && object.getClass() === Class.AudioObject)
  }
}

